// @flow
import type {IntlShape} from 'react-intl';

export const cappedTotal = 300;

export const cappedTotalText = '300+';

const resultsCountText = (
    from: number,
    to: number,
    total: number,
    intl: IntlShape
): string => {
    const cappedTotalKey = 'page.countTotalCapped';
    const id = total <= cappedTotal ? 'page.countTotal' : cappedTotalKey;
    return intl.formatMessage(
        {id, defaultMessage: cappedTotalKey},
        {from, to, total, cappedTotal}
    );
};

export default resultsCountText;
